module.exports = __webpack_public_path__ + "1fdf6d5f879da12fb321b493968a107b.pdf";